/* everstory-consent.js — the answer everstory-meta.js has always been waiting for.
 *
 * The Customer Privacy API is not present on this store by default; it has to be asked for with
 * Shopify.loadFeatures, which is the same call everstory-meta.js makes. Both asking is harmless:
 * loadFeatures is idempotent and each caller gets its own callback.
 *
 * WHAT DECIDES WHETHER THE BAR APPEARS. Shopify's own shouldShowBanner(), not our guess about the
 * visitor's country. It reads the store's regional privacy settings, and it returns false once an
 * answer is stored, so the bar shows once and then never again. If that call is unavailable the
 * fallback is the same test everstory-meta.js uses: an empty marketing string means unanswered.
 *
 * Setting consent raises Shopify's `visitorConsentCollected`, which everstory-meta.js already
 * listens for. So accepting here loads fbevents.js, flushes the queued PageView and ViewContent,
 * and starts the _fbp handoff onto the cart, with no coupling between the two files beyond the
 * event Shopify itself publishes.
 */
(function () {
  var bar = document.getElementById('es-consent');
  if (!bar) return;

  function api() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  function loadApi(done) {
    if (api()) { done(); return; }
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () { done(); }
        );
        return;
      }
    } catch (e) {}
    done();
  }

  /** True when Shopify wants an answer from this visitor and does not have one yet. */
  function wanted() {
    var a = api();
    if (!a) return false;
    try {
      if (typeof a.shouldShowBanner === 'function') return a.shouldShowBanner() === true;
    } catch (e) {}
    try {
      var c = a.currentVisitorConsent && a.currentVisitorConsent();
      return !!c && (!c.marketing || c.marketing === '');
    } catch (e) {}
    return false;
  }

  function hide() {
    bar.setAttribute('hidden', '');
  }

  function answer(granted) {
    var a = api();
    hide();
    if (!a || typeof a.setTrackingConsent !== 'function') return;
    try {
      a.setTrackingConsent(
        {
          marketing: granted,
          analytics: granted,
          preferences: granted,
          sale_of_data: granted
        },
        function () {}
      );
    } catch (e) {}
  }

  bar.querySelector('[data-consent-yes]').addEventListener('click', function () { answer(true); });
  bar.querySelector('[data-consent-no]').addEventListener('click', function () { answer(false); });

  loadApi(function () {
    // The feature can land a moment after its own callback, which is the case everstory-meta.js
    // documents and polls for. Same backstop here, and the bar simply stays hidden if no answer is
    // ever wanted.
    if (wanted()) { bar.removeAttribute('hidden'); return; }
    var tries = 0;
    var poll = setInterval(function () {
      if (wanted()) { bar.removeAttribute('hidden'); clearInterval(poll); return; }
      if (++tries > 20) clearInterval(poll);
    }, 500);
  });
})();
